import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  Button,
  Box,
  Typography,
  TextField,
  Tooltip,
} from "@mui/material";
import closeIcon from "../../../src/assests/images/close-circle.svg";
import { AxiosError, AxiosResponse } from 'axios';
import EditCohortFilter from "./EditCohortFilter";
import { useNavigate, useParams } from "react-router-dom";
import { getToken } from "../../utils/utils";
import { editcohorts } from "../../pages/assign-task/api";
import Plus from "../../../src/assests/images/Plus.svg";
import EditIcon from "../../../src/assests/images/edit-2.svg";
import { useAlert } from "../../pages/AlertContext/AlertContext";
import CohortIcon from "../../../src/assests/images/cohort-icon.svg";

// Define Filters interface to match EditCohortFilter.tsx

interface Outlet {
  id: number | string;
  name: string;
}
interface Filters {
  outletTypes: { [key: string]: boolean };
  locations: { [key: string]: boolean };
  status: { [key: string]: boolean };
  Contract_since: { [key: string]: boolean };
  Current_rental_value: { [key: string]: boolean };
  asmNames: { [key: string]: boolean };
  territoryCodes: { [key: string]: boolean };
  taskNames: { [key: string]: boolean };
  region: { [key: string]: boolean };
  [key: string]: { [key: string]: boolean }; // Index signature for dynamic access
}

interface CreateCohortProps {
  buttonText: string;
  buttonVariant: "contained" | "outlined";
  buttonIcon?: string;
  type?: "default" | "edit";
  onClick?: (id: string) => void;
  cohortId?: string;
  cohortname: string;
  outletType: string[]; // Changed to string[] to match EditCohortFilter
  cohort_type?: string;
  outletnames?: Outlet[];
}

const EditCohort: React.FC<CreateCohortProps> = ({
  buttonText,
  buttonVariant,
  buttonIcon,
  type = "default",
  onClick,
  cohortId,
  cohortname,
  outletType,
  cohort_type,
  outletnames
}) => {
  const [open, setOpen] = useState(false);
  const [cohortName, setCohortName] = useState<string>(cohortname || "");
  const [selectedOutletTypes, setSelectedOutletTypes] = useState<string[]>([]);
  const [selectedlocationstypes, setSelectedlocationstypes] = useState<string[]>([]);
  const [filters, setFilters] = useState<Filters>({
    outletTypes: {},
    locations: {},
    status: { Active: false, Inactive: false },
    Contract_since: { Last1Year: false, Last3Year: false, Last6Year: false }, // Updated to match EditCohortFilter
    Current_rental_value: { "0-2000": false, "2000-40000": false, "4000-50000": false },
    asmNames: {},
    territoryCodes: {},
    taskNames: {},
    region: {}, // Added region to match EditCohortFilter
  });

  const [cohortid, setCohortId] = useState<string>(cohortId || "");
  const { id } = useParams();
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const token = getToken();

  const handleOpen = () => {
    setOpen(true);
    if (onClick && cohortId) {
      setCohortId(cohortId);
      setCohortName(cohortname);
      onClick(cohortId);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setCohortName("");
  };

  const handleCohortNameChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setCohortName(event.target.value);
  };

  useEffect(() => {
    if (cohortname) {
      setCohortName(cohortname);
    }
    if (cohortId) {
      setCohortId(cohortId);
    }
    // Initialize filters with default outletType values
    if (outletType && outletType.length > 0) {
      setFilters((prev) => ({
        ...prev,
        outletTypes: outletType.reduce((acc, type) => {
          acc[type] = true;
          return acc;
        }, {} as { [key: string]: boolean }),
      }));
      setSelectedOutletTypes(outletType);
    }
  }, [cohortname, cohortId, outletType]);

  const selectedoutlettypes = Object.entries(filters.outletTypes)
    .filter(([key, value]) => value === true && key.toLowerCase() !== "alltypes")
    .map(([key]) => key);

  const selectedstatus = Object.entries(filters.status)
    .filter(([key, value]) => value === true && key.toLowerCase() !== "alltypes")
    .map(([key]) => key);

  const selectedContract_since = Object.entries(filters.Contract_since)
    .filter(([key, value]) => value === true && key.toLowerCase() !== "alltypes")
    .map(([key]) => key);

  const selectedCurrent_rental_value = Object.entries(filters.Current_rental_value)
    .filter(([key, value]) => value === true && key.toLowerCase() !== "alltypes")
    .map(([key]) => key);


  const selectedLocations = Object.entries(filters.locations)
    .filter(([key, value]) => value && key.toLowerCase() !== 'all')
    .map(([key]) => key);

  const selectedOutletTypes1 = Object.entries(filters.outletTypes)
    .filter(([key, value]) => value && key.toLowerCase() !== 'alltypes')
    .map(([key]) => key);

  const selectedRegions = Object.entries(filters.region)
    .filter(([key, value]) => value)
    .map(([key]) => key);

  const selectedStatus = Object.entries(filters.status)
    .filter(([key, value]) => value)
    .map(([key]) => key);

  const selectedContractSince = Object.entries(filters.Contract_since)
    .filter(([key, value]) => value)
    .map(([key]) => key);

  const selectedCurrentRentalValue = Object.entries(filters.Current_rental_value)
    .filter(([key, value]) => value)
    .map(([key]) => key);

  const selectedTaskNames = Object.entries(filters.taskNames)
    .filter(([key, value]) => value)
    .map(([key]) => key); // Match outlet_names casing

  const selectedAsmNames = Object.entries(filters.asmNames)
    .filter(([key, value]) => value)
    .map(([key]) => key);

  const selectedTerritoryCodes = Object.entries(filters.territoryCodes)
    .filter(([key, value]) => value)
    .map(([key]) => key);

  const handleSave = async () => {
    showAlert("Saving cohort...", "info");
    const reqBody = {
      // locations: Array.isArray(selectedLocations) ? selectedLocations : [],
      // outlet_type: Array.isArray(selectedoutlettypes) ? selectedoutlettypes : [],
      // status: Array.isArray(selectedstatus) ? selectedstatus : [],
      // Contract_since: Array.isArray(selectedContract_since) ? selectedContract_since : [],
      // Current_rental_value: Array.isArray(selectedCurrent_rental_value)
      //   ? selectedCurrent_rental_value
      //   : [],
      // cohortName,

      locations: selectedLocations,
      outlet_type: selectedOutletTypes1,
      region: selectedRegions,
      status: selectedStatus,
      Contract_since: selectedContractSince,
      Current_rental_value: selectedCurrentRentalValue,
      task_names: selectedTaskNames,
      asm_names: selectedAsmNames,
      territory_codes: selectedTerritoryCodes,
      outlet_names: selectedTaskNames, // Map taskNames to outlet_names
      cohortName,
      task_id: id || 'undefined',

      cohort_id: cohortid,
    };

    try {
      const response = await editcohorts(reqBody, token);
      if (response) {
        console.log("Cohort saved successfully.");
        setOpen(false);
        showAlert("Cohort saved successfully!", "success");
        navigate(`/cohorts-view`);
        setTimeout(() => window.location.reload(), 100);
      } else {
        console.error("Failed to save cohort.", response);

      }
    } catch (error) {
      // Handle AxiosError specifically
      if (error instanceof AxiosError && error.response?.data?.message) {
        console.error('Error saving cohort:', error.response.data);
        showAlert(error.response.data.message, 'error');
      } else if (error instanceof Error) {
        console.error('Error saving cohort:', error);
        showAlert(error.message || 'An error occurred while saving the cohort.', 'error');
      } else {
        console.error('Unknown error saving cohort:', error);
        showAlert('An unexpected error occurred.', 'error');
      }
    }
  };
  console.log("cohort_type in EditCohort:", outletType);
console.log("filters in EditCohort:", filters);
  return (
    <div>

      {/* <Tooltip
        title={buttonText === "Edit" ? "Edit" : "Create a new cohort"}
        arrow
      > */}
      <Button
        variant={buttonVariant}
        color="primary"
        onClick={handleOpen}
        sx={{
          borderRadius: "20px",
          padding: "14px 16px",
          color:
            buttonText === "Edit" || buttonVariant === "contained"
              ? "#FFF"
              : "rgba(200, 23, 47, 1)",
          textDecoration: "none",
          background:
            buttonVariant === "contained" ? "rgba(200, 23, 47, 1)" : "#fff",
          textAlign: "center",
          fontWeight: "500",
          textTransform: "none",
          width: buttonText === "Edit" ? "10px" : "150px",
          border:
            buttonText === "Edit" || buttonVariant === "contained"
              ? "none"
              : "1px solid rgba(200, 23, 47, 1)",
          "&:hover": {
            boxShadow: "none",
          },
        }}
      >
        <img
          src={buttonText === "Edit" ? EditIcon : Plus}
          alt="button-icon"
        />
        <Typography sx={{ fontSize: "14px", paddingLeft: "10px" }}>
          {buttonText}
        </Typography>
      </Button>
      {/* </Tooltip> */}

      <Dialog
        open={open}
        onClose={handleClose}
        sx={{
          borderRadius: "10px",
          "& .MuiPaper-elevation": { borderRadius: "10px" },
        }}
      >

        <DialogTitle
          sx={{
            width: "480px",
            padding: "0",
            minHeight: "150px",
            maxHeight: "430px",
            borderRadius: "10px",
            overflowY: "overlay",

            "@media (min-width: 1440px)": {
              minHeight: "150px",
              maxHeight: "550px",
            },
          }}
        >
          <Box sx={{ width: "100%" }}>
            <Box
              sx={{
                // display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid #bdbdbd",
                paddingBottom: "10px",
                //position: "sticky",
                // width: "450px",
                overflow: "hidden",
                top: "0rem",
                background: "#fff",
                zIndex: 9,
                borderTopLeftRadius: "10px",
                borderTopRightRadius: "10px",
                display: "flex"
              }}
            >
              <Typography
                sx={{
                  marginLeft: "0px",
                  marginTop: "20px",
                  fontSize: "24px",
                  fontWeight: "600",
                  padding: "0 20px",
                  display: "flex",
                }}
              >
                <img
                  src={CohortIcon}
                  alt="CohortIcon"
                  style={{ position: "relative", top: "-5px", marginRight: "10px" }}
                />
                {cohort_type === "Static Cohort" ? " Static Edit Cohort" : "Dynamic Edit Cohort"}
                {/* Edit Cohort */}
              </Typography>
              <Tooltip title="Close the dialog" arrow>
                <Button
                  onClick={handleClose}
                  color="primary"
                  sx={{
                    borderRadius: "50%",
                    minWidth: "30px",
                    color: "#000",
                    fontSize: "10px",
                    position: "relative",
                    right: "10px",
                    top: "5px",

                    "& :hover": {
                      background: "none",
                    },
                  }}
                >
                  <img src={closeIcon} alt="close" width="15px" />
                </Button>
              </Tooltip>
            </Box>

            <Box sx={{ padding: "0 20px", marginTop: "0rem" }}>
              <Typography
                variant="subtitle2"
                sx={{
                  mt: 2,
                  color: "#282829",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
                Cohort Name

              </Typography>
              <Tooltip title={cohortName || "Enter Cohort name"} arrow>

                <TextField
                  placeholder="Enter Cohort name"
                  sx={{ border: "1px solid #E7E8E9", borderRadius: "10px" }}
                  name="Name"
                  fullWidth
                  margin="normal"
                  required
                  value={cohortName}
                  onChange={handleCohortNameChange}
                />
              </Tooltip>
              {outletType?.length > 0 ? (
                <Typography
                  variant="subtitle2"
                  sx={{
                    mt: 2,
                    color: "#282829",
                    fontSize: "16px",
                    fontWeight: "600",
                  }}
                >
                  Apply Filter
                </Typography>
              ) : (
                <Typography
                  variant="subtitle2"
                  sx={{
                    mt: 2,
                    color: "#282829",
                    fontSize: "16px",
                    fontWeight: "600",
                  }}
                >
                  No filters available
                </Typography>
              )}

              <EditCohortFilter
                cohort_type={cohort_type}
                filters={filters}
                setFilters={setFilters}
                selectedlocationstypes={selectedlocationstypes}
                setSelectedlocationstypes={setSelectedlocationstypes}
                filter={undefined}
                defaultfiletrs={outletType} // Now correctly typed as string[]
                outletnames={outletnames}
              />
              <Box
                sx={{
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Tooltip title="Cancel" arrow>
                  <Button
                    onClick={handleClose}
                    sx={{
                      border: "1px solid #7D7E7F",
                      color: "#7D7E7F",
                      textTransform: "capitalize",
                      background: "#FFF",
                      marginLeft: "20px",
                      padding: "8px 20px",
                      borderRadius: "10px",
                      marginBottom: "30px",
                    }}
                  >
                    Cancel
                  </Button>
                </Tooltip>
                <Tooltip title="Save and proceed" arrow>
                  <Button
                    onClick={handleSave}
                    sx={{
                      border: "1px solid #7D7E7F",
                      color: cohortName ? "#FFF" : "#7D7E7F",
                      textTransform: "capitalize",
                      background: cohortName ? "#C8172F" : "#FFF",
                      marginLeft: "20px",
                      padding: "8px 20px",
                      borderRadius: "10px",
                      marginBottom: "30px",
                    }}
                    disabled={!cohortName}
                  >
                    Save
                  </Button>
                </Tooltip>
              </Box>
            </Box>
          </Box>
        </DialogTitle>

      </Dialog>

    </div>
  );
};

export default EditCohort;